<template>
  <UserDataProvider v-slot="{user, loaded}">
    <v-list
      v-if="loaded"
      flat
      :dense="$vuetify.breakpoint.mdAndUp"
      class="nav-header"
      style="background-image: url('img/slide23.jpg'); background-size: cover; background-repeat: no-repeat;"
    >
      <v-list-item>
        <v-list-item-avatar
          color="primary"
          size="62"
        >
          <span
            class="white--text text-h6"
          >{{user?.initials || ''}}</span>
        </v-list-item-avatar>
      </v-list-item>

      <v-list-item
        class="pt-0"
      >
        <v-list-item-content>
          <v-list-item-title
            class="text-h6"
          >
            {{user?.name || ''}}
          </v-list-item-title>
          <v-list-item-subtitle>{{user?.email || ''}}</v-list-item-subtitle>
          <v-list-item-subtitle>{{user?.companyName || user?.location?.name || user?.organization?.name || ''}}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </UserDataProvider>
</template>

<script>
import UserDataProvider from '@/components/frames/UserDataProvider'

export default {
  name: 'NavHeader',
  components: {
    UserDataProvider
  }
}
</script>
@/components/frames/UserDataProvider
